import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  contactForm = this.fb.group({
    name: ["", Validators.required],
    email:["", Validators.required],
    subject:["", Validators.required],
    text:["", Validators.required]
  
  });

  constructor(private toastr: ToastrService, private fb: UntypedFormBuilder) { }

  ngOnInit(): void {

  }
  onSubmit(form: UntypedFormGroup) {
    this.toastr.success('E-mail sent successfully');
    form.reset();
  }

}
